import React from "react";
import { PageLayout } from "../../../components";
import { useSourceSystem } from "../../../hooks/useSourceSystem";

export default function IneligibleVehicleError() {
  const { sourceSystem } = useSourceSystem();

  const {
    stepPercentage,
    errorMain,
    errorHint,
    primaryButtonText,
    secondaryButtonText,
    showAltButton
  } = sourceSystem.ineligibleVehicleError.ineligibleVehicleErrorContent;

  return (
    <PageLayout>
      <PageLayout.Header title="Registration" step={stepPercentage} />
      <div className="ch-container ch-mt--4 md:ch-width--4 sm:ch-width--5 ch-width--12 sl:ch-width--8 ">
        <div
          className="ch-alert ch-alert--warning ch-fs--3 "
          style={{ border: "solid 1px orange" }}
        >
          <p className="ch-text--bold">{errorMain}</p>
          <p className="ch-fs--2">{errorHint}</p>
        </div>
      </div>
      <div className="reg-error-page-layout--bottom-fixed ch-bg--grey-1 sm:ch-mt--10">
        <button
          className="ch-btn ch-btn--success ch-btn--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
          onClick={() =>
            sourceSystem.ineligibleVehicleError.onClickIneligibleVehiclePrimary()
          }
        >
          {primaryButtonText}
        </button>
        {showAltButton && (
          <button
            className="ch-btn ch-btn--block ch-mh--auto sm:ch-width--6 md:ch-width--5 ch-width--12 lg:ch-width--4"
            onClick={() =>
              sourceSystem.ineligibleVehicleError.onClickIneligibleVehicleSecondary()
            }
          >
            {secondaryButtonText}
          </button>
        )}
      </div>
    </PageLayout>
  );
}
